import * as THREE from 'three'
import { OrbitControls } from '../control/OrbitControls'
import { LHFEventDispatcher } from '../../com/LHFEventDispatcher'
import { Events } from '../../com/Events'
import TWEEN from 'tween.js'
import { PANO_CONFIG } from './PanoConfig'

class PanoRenderMain extends LHFEventDispatcher {
  constructor(container_) {
    super()
    this.domContainer = container_
    this.curFov = PANO_CONFIG.FOV

    // 场景切换动画状态
    this.sceneSwitchAniStatus = false

    this.init()
    this.initScaleControl()
  }

  zoomIn(val){
    let fov = (this.curFov /= val)
    if (fov > PANO_CONFIG.FOV_MAX) fov = PANO_CONFIG.FOV_MAX
    this.curFov = fov
    this.camera.fov = fov
    this.camera.updateProjectionMatrix()
  }
  zoomOut(val){

    let fov = (this.curFov *= val)
    if (fov < PANO_CONFIG.FOV_MIN) fov = PANO_CONFIG.FOV_MIN
    this.curFov = fov
    this.camera.fov = fov
    this.camera.updateProjectionMatrix()
}

  initScaleControl() {
    this.control.panorama = true
    this.control.addEventListener(Events.PANORAMA_ZOOM_IN, e => {
      let fov = (this.curFov /= e.val)
      if (fov > PANO_CONFIG.FOV_MAX) fov = PANO_CONFIG.FOV_MAX
      this.curFov = fov
      this.camera.fov = fov
      this.camera.updateProjectionMatrix()
    })
    this.control.addEventListener(Events.PANORAMA_ZOOM_OUT, e => {
      let fov = (this.curFov *= e.val)
      if (fov < PANO_CONFIG.FOV_MIN) fov = PANO_CONFIG.FOV_MIN
      this.curFov = fov
      this.camera.fov = fov
      this.camera.updateProjectionMatrix()
    })
  }

  setScene(scene_) {
    this.scene = scene_
  }

  init() {
    this.renderer = new THREE.WebGLRenderer({
      antialias: true,
      alpha: false
    })
    this.renderer.setPixelRatio(window.devicePixelRatio)
    this.renderer.autoClear = false

    /**         * 帧缓冲  用于制作场景切换动画         */

    this.switchFrameBufferComplate = false
    this.switchAniStartStatus = false

    this.textureSize_W = PANO_CONFIG.V_WIDTH * window.devicePixelRatio
    this.textureSize_H = PANO_CONFIG.V_HEIGHT * window.devicePixelRatio

    let halfW = PANO_CONFIG.V_WIDTH / 2
    let halfH = PANO_CONFIG.V_HEIGHT / 2

    this.orthoCamera = new THREE.OrthographicCamera(
      -halfW,
      halfW,
      halfH,
      -halfH,
      1,
      10
    )
    this.orthoCamera.position.z = 10

    this.orthoScene = new THREE.Scene()
    let dataTextureArray = new Uint8Array(
      this.textureSize_W * this.textureSize_H * 3
    )
    this.sceneSwitchTexture = new THREE.DataTexture(
      dataTextureArray,
      this.textureSize_W,
      this.textureSize_H,
      THREE.RGBFormat
    )
    this.sceneSwitchTexture.minFilter = THREE.NearestFilter
    this.sceneSwitchTexture.magFilter = THREE.NearestFilter
    this.sceneSwitchTexture.needsUpdate = true
    this.sceneSwitchSpriteMaterial = new THREE.SpriteMaterial({
      map: this.sceneSwitchTexture,
      transparent: true,
      opacity: 1
    })
    this.sceneSwitchAniSprite = new THREE.Sprite(this.sceneSwitchSpriteMaterial)
    this.sceneSwitchAniSprite.scale.set(
      this.textureSize_W,
      this.textureSize_H,
      1
    )
    this.orthoScene.add(this.sceneSwitchAniSprite)

    /**         * 创建缓动         */
    this.tweenAni = new TWEEN.Tween(this.sceneSwitchSpriteMaterial)
    this.tweenAni.delay(500)
    /*this.tweenAni.onUpdate(()=>{
    })*/
    this.tweenAni.onComplete(() => {
      this.sceneSwitchAniStatus = false // 过度结束切换为非过度状态
      console.log('dispatch scene switch end')
      this.dispatchEvent({ type: Events.SCENE_SWITCH_END })
    })

    let aspect_ = PANO_CONFIG.V_WIDTH / PANO_CONFIG.V_HEIGHT
    this.camera = new THREE.PerspectiveCamera(
      this.curFov,
      aspect_,
      0.1,
      20000
    )
    this.camera.position.copy(PANO_CONFIG.defaultCameraPosition)
    let zero = new THREE.Vector3()
    this.camera.lookAt(zero)
    this.control = new OrbitControls(this.camera, this.domContainer)
    //this.control.maxPolarAngle = Math.PI;

    this.control.minPolarAngle = Math.PI*0.3
    this.control.update()
    this.domContainer.appendChild(this.renderer.domElement)
    this.enabled = true
  }

  /**     * 切换动画启动     */
  switchAniStart() {
    this.tweenAni.stop()
    this.sceneSwitchAniStatus = true
    this.sceneSwitchSpriteMaterial.opacity = 1
    this.renderer.clear()
    this.renderer.render(this.scene, this.camera)
    //  开始场景切换 复制帧缓冲区域
    let vector = new THREE.Vector2()
    this.renderer.copyFramebufferToTexture(vector, this.sceneSwitchTexture)
    return new Promise(resolve => {
      this.switchAniStartFun()
      resolve()
    })
  }

  /**     * 启动     */
  switchAniStartFun() {
    this.sceneSwitchSpriteMaterial.opacity = 1
    this.switchFrameBufferComplate = this.switchAniStartStatus = false
    this.tweenAni.to({ opacity: 0 }, 1000)
    this.tweenAni.start()
  }

  render() {
    if (!this.enabled) return
    // if (!this.control.updateStatus) return
    this.control.updateStatus = false
    this.control.tweenUpdate()
    this.renderer.clear()
    this.renderer.render(this.scene, this.camera)

    // 是否处于场景切换动画阶段
    if (this.sceneSwitchAniStatus) {
      // 利用帧缓冲 渲染过度动画
      this.renderer.clearDepth()
      console.log('renderer ani status')
      this.renderer.render(this.orthoScene, this.orthoCamera)
    }
    this.renderer.clearDepth()
  }

  resize(w_, h_) {
    PANO_CONFIG.V_HEIGHT = h_
    PANO_CONFIG.V_WIDTH = w_
    this.camera.aspect = PANO_CONFIG.V_WIDTH / PANO_CONFIG.V_HEIGHT
    this.camera.updateProjectionMatrix()
    this.orthoCamera.left = -w_ / 2
    this.orthoCamera.right = w_ / 2
    this.orthoCamera.top = h_ / 2
    this.orthoCamera.bottom = -h_ / 2
    this.orthoCamera.updateProjectionMatrix()
    this.updateSpritePosition()
    this.textureSize_W = PANO_CONFIG.V_WIDTH * window.devicePixelRatio
    this.textureSize_H = PANO_CONFIG.V_HEIGHT * window.devicePixelRatio
    this.sceneSwitchAniSprite.scale.set(
      this.textureSize_W,
      this.textureSize_H,
      1
    )
    let dataTextureArray = new Uint8Array(
      this.textureSize_W * this.textureSize_H * 3
    )
    this.sceneSwitchTexture = new THREE.DataTexture(
      dataTextureArray,
      this.textureSize_W,
      this.textureSize_H,
      THREE.RGBFormat
    )
    this.sceneSwitchTexture.minFilter = THREE.NearestFilter
    this.sceneSwitchTexture.magFilter = THREE.NearestFilter
    this.sceneSwitchTexture.needsUpdate = true
    this.sceneSwitchSpriteMaterial.map = this.sceneSwitchTexture
    this.renderer.setSize(w_, h_)
  }

  updateSpritePosition() {
    let halfWidth = PANO_CONFIG.V_WIDTH / 2
    let halfHeight = PANO_CONFIG.V_HEIGHT / 2
    let halfImageWidth = PANO_CONFIG.V_WIDTH / 2
    let halfImageHeight = PANO_CONFIG.V_HEIGHT / 2
    this.sceneSwitchAniSprite.position.set(
      -halfWidth + halfImageWidth,
      halfHeight - halfImageHeight,
      1
    )
  }
}

export { PanoRenderMain }



// WEBPACK FOOTER //
// ./src/webgl/panorama/PanoRenderMain.js